/*----- Colors -----*/
export const colors = {
  call_to_action: `#2CC682`,
  call_to_action_secondary: `#22B876`,

  neutral: `#162687`,
  neutral_secondary: `#0F1955`,

  default: `#FFFFFF`,

  destructive: `#F44141`,
  destructive_secondary: `#d03737`,

  disabled: `#64748B`,
  text_disabled: `#94A3B8`,

  tertiary: `#F4F7FC`,
  body: `#6E80A9`,
}

/*----- Settings -----*/
const scale = 2.25
export const settings = {
  scale,
  borderRadius: `${ 4 * scale }px`
}